import { IGraphQLDataCollection } from "@app/models/graphql";
import {
  DEFAULT_SORTING_ORDER_NUMBER,
  DIMENSION_SORT_ORDER_NAME,
} from "./constants";
import { FAQCategories } from "./types";

export const getSortingNumber = (
  categoryList: IGraphQLDataCollection<FAQCategories>,
  categoryId: string,
) => {
  const sortingNumber = parseInt(
    categoryList.edges.filter(
      (dataItem) =>
        dataItem.node.id === categoryId &&
        dataItem.node.dimensionName === DIMENSION_SORT_ORDER_NAME,
    )[0]?.node.dimensionValue,
  );

  return isNaN(sortingNumber) ? DEFAULT_SORTING_ORDER_NUMBER : sortingNumber;
};
